import React from "react"

import { Box, Text, Button, Flex, Input, theme } from "@singita/components"

export const language = {
  donation: {
    headline: "Your donation makes a difference",
    labelAmount: "Donation Amount",
    labelAmountOther: "Other Amount",
    labelRecurring: "Repeat this donation monthly",
    buttonNext: "Next",
    notes: "Notes on Gift Designation",
  },
}

const amounts = [
  {
    label: "$ 500",
    amount: 500,
  },
  {
    label: "$ 1000",
    amount: 1000,
  },
  {
    label: "$ 5,000",
    amount: 5000,
  },
  {
    label: "$ 10,000",
    amount: 10000,
  },
  {
    label: "$ 50,000",
    amount: 50000,
  },
]
const Donation = ({
  error,
  onSetValues,
  values,
  onNext = () => {},
  onError,
}) => {
  let amountList = amounts

  const onSubmit = () => {
    if (!values.amount) {
      if (onError) {
        onError("Please enter amount")
      }
    } else {
      onNext()
    }
  }
  return (
    <>
      <Text size="small" fontWeight="bold" b={[1, 5]}>
        {language.donation.labelAmount}
      </Text>
      <Flex sx={{ flexDirection: "column" }}>
        <Flex
          mb={[1]}
          sx={{ justifyContent: "space-between", flexWrap: "wrap" }}
        >
          {amountList
            .sort((a, b) => (a.amount > b.amount ? 1 : -1))
            .map(amt => {
              return (
                <Button
                  mb={[2]}
                  variant={
                    values.amount === amt.amount && !values.other
                      ? "primary"
                      : "outline"
                  }
                  onClick={() =>
                    onSetValues({ amount: amt.amount, other: false })
                  }
                >
                  {amt.label}
                </Button>
              )
            })}
        </Flex>
      </Flex>
      <Box mb={[2]}>
        <Text size="small" fontWeight="bold" mb={[1, 2]}>
          {language.donation.labelAmountOther}
        </Text>
        <Input
          bg={theme.colors.baseGrayVeryLight}
          onChange={e =>
            onSetValues({ amount: parseFloat(e.target.value), other: true })
          }
          value={values.other ? values.amount : ""}
        />
      </Box>
      <Box mb={[2]}>
        <Text size="small" fontWeight="bold" mb={[1, 2]}>
          {language.donation.notes}
        </Text>
        <Input
          type="textarea"
          bg={theme.colors.baseGrayVeryLight}
          onChange={e => onSetValues({ notes: e.target.value })}
          value={values.notes}
        />
      </Box>
      {error ? (
        <Box mt={[3]} bg="brandRed">
          <Text>{error}</Text>
        </Box>
      ) : null}
      <Flex justifyContent="space-between">
        <Box />
        {onNext ? (
          <Box mt={[3]}>
            <Button
              variant="text"
              icon="angle-right"
              iconPosition="right"
              onClick={onSubmit}
            >
              {language.donation.buttonNext}
            </Button>
          </Box>
        ) : null}
      </Flex>
    </>
  )
}

export default Donation
